import { AlertTriangle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

// ADV-1101: per-field affordance for a value the lenient import pre-pass
// could not validate (e.g. `n/a@gmail.com`). The badge shows next to the
// raw value on the contact-detail page and surfaces the import's `reason`
// as a hover/title tooltip. Tokens map to `--color-warning` per ADR-0018.
//
// Visual register is intentionally restrained — a single icon + 3-word
// label — so the badge fades into the row when many rows have it (a brand-
// new import) but stays scannable when only one row carries it.
export function UnresolvedFieldBadge({
  reason,
}: {
  reason: string | null | undefined;
}) {
  return (
    <Badge
      variant="outline"
      title={reason ?? "Imported value could not be validated"}
      className="gap-1 border-[color:var(--color-warning)]/40 text-[color:var(--color-warning)]"
    >
      <AlertTriangle className="h-3 w-3" aria-hidden />
      Imported — not validated
    </Badge>
  );
}
